import {ChangeDetectionStrategy, Component, EffectRef, InputSignal, OnDestroy, OutputEmitterRef, Signal, computed, effect, inject, input, linkedSignal, output} from '@angular/core';
import {DialogService} from "../../services/dialog.service";
import {EmojiPillDialogComponent} from "./emoji-pill-dialog.component";
import {DynamicDialogRef} from "../../services/dialog.service";
import {EmojiPillItem} from "./emoji-pill.types";

@Component({
  selector: 'app-emoji-pill',
  imports: [],
  templateUrl: './emoji-pill.component.html',
  styleUrl: './emoji-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmojiPillComponent implements OnDestroy {
  public dialogService: DialogService = inject(DialogService);

  public emojis: InputSignal<EmojiPillItem[]> = input<EmojiPillItem[]>([]);
  public totalCount: InputSignal<number | null> = input<number | null>(null);
  public ownMessage: InputSignal<boolean> = input<boolean>(false);
  public height: InputSignal<string> = input<string>('auto');
  public textSize: InputSignal<string> = input<string>('0.75rem');
  public deleteEmoji: OutputEmitterRef<number> = output<number>();
  public openRequest: OutputEmitterRef<void> = output<void>();
  private dialogRef: DynamicDialogRef<EmojiPillDialogComponent> | null = null;

  public totalEmojiCount: Signal<number> = linkedSignal(() => this.totalCount() ?? this.emojis().length);

  public previewEmojis: Signal<string[]> = computed(() => {
    const uniqueEmojis: string[] = [];
    this.emojis().forEach((emojiItem) => {
      if (!uniqueEmojis.includes(emojiItem.emoji)) {
        uniqueEmojis.push(emojiItem.emoji);
      }
    });
    return uniqueEmojis.slice(0, 2);
  });

  private dialogSyncEffect: EffectRef = effect(() => {
    if(this.emojis()) { // this if statement is necessary for the effect to fire correctly
      if (!this.dialogRef) {
        return;
      }
      this.dialogRef.componentRef.setInput('emojis', this.emojis());
      this.dialogRef.componentRef.setInput('visible', this.totalEmojiCount() > 0);
  
      if (this.totalEmojiCount() === 0) {
        this.closeDialog();
      }
    }
  });

  public ngOnDestroy(): void {
    this.closeDialog();
    this.dialogSyncEffect.destroy();
  }

  public openDialog(): void {
    if (this.totalEmojiCount() === 0 || this.dialogRef) {
      return;
    }

    this.openRequest.emit();
    this.dialogRef = this.dialogService.openComponent(EmojiPillDialogComponent, {
      emojis: this.emojis(),
      visible: true
    });

    this.dialogRef.componentRef.instance.deleteEmoji.subscribe((referenceId) => {
      this.deleteEmoji.emit(referenceId);
    });
    this.dialogRef.componentRef.instance.closeRequest.subscribe(() => {
      this.closeDialog();
    });
  }

  public closeDialog(): void {
    this.dialogRef?.close();
    this.dialogRef = null;
  }
}
